import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Portfolio.css';

const projects = [
  {
    title: 'Construction Management System',
    description: 'Workflow management with tracking, reporting, and team collaboration.',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&auto=format&fit=crop',
    tags: ['Web App', 'Dashboard'],
  },
  {
    title: 'E-Commerce Platform',
    description: 'Online store with payment integration, inventory, and order management.',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&auto=format&fit=crop',
    tags: ['E-Commerce', 'Web'],
  },
  {
    title: 'Mobile Applications',
    description: 'High-performance Android & iOS apps for retail and field operations.',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=600&auto=format&fit=crop',
    tags: ['Mobile', 'iOS', 'Android'],
  },
  {
    title: 'Business Automation',
    description: 'Custom web solutions for process automation and reporting.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&auto=format&fit=crop',
    tags: ['Web App', 'Automation'],
  },
  {
    title: 'Hostel Management Software',
    description: 'Complete hostel system for admissions, room management, fees, and student tracking.',
    image: 'https://images.unsplash.com/photo-1555854877-bab0e564b8d5?w=600&auto=format&fit=crop',
    tags: ['Management System', 'Education'],
  },
  {
    title: 'POS Software Suite',
    description: 'Billing, inventory, and sales analytics platform for stores and food businesses.',
    image: 'https://images.unsplash.com/photo-1556740738-b6a63e27c4df?w=600&auto=format&fit=crop',
    tags: ['POS', 'Retail'],
  },
  {
    title: 'ERP / CRM Platform',
    description: 'Unified ERP and CRM platform to manage departments, leads, and customer journeys.',
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=600&auto=format&fit=crop',
    tags: ['ERP', 'CRM'],
  },
];

const servicePills = [
  { label: 'Web Development', path: '/web-development' },
  { label: 'Mobile Development', path: '/mobile-app' },
  { label: 'Cloud Solutions', path: '/cloud-solutions' },
  { label: 'IT Support', path: '/it-support' },
  { label: 'Hostel Management', path: '/contact' },
  { label: 'POS Software', path: '/contact' },
  { label: 'ERP / CRM Systems', path: '/contact' },
  { label: 'Management Systems', path: '/contact' },
];

const Portfolio = () => {
  return (
    <div className="portfolio-page">
      <section className="portfolio-hero">
        <div className="container">
          <motion.h1
            className="portfolio-hero-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            Our Portfolio
          </motion.h1>
          <motion.p
            className="portfolio-hero-subtitle"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            Innovative IT solutions delivered for businesses across industries
          </motion.p>
        </div>
      </section>

      <section className="portfolio-projects section">
        <div className="container">
          <h2 className="section-title">Featured Projects</h2>
          <p className="section-subtitle">
            A selection of our recent work in web, mobile, and cloud solutions
          </p>
          <div className="portfolio-grid">
            {projects.map((project, index) => (
              <motion.article
                key={index}
                className="portfolio-card"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-20px' }}
                transition={{ duration: 0.4, delay: index * 0.08 }}
                whileHover={{ y: -6 }}
              >
                <div className="portfolio-card-image">
                  <img src={project.image} alt={project.title} />
                  <div className="portfolio-card-overlay" />
                </div>
                <div className="portfolio-card-body">
                  <div className="portfolio-card-tags">
                    {project.tags.map((tag, i) => (
                      <span key={i} className="portfolio-tag">{tag}</span>
                    ))}
                  </div>
                  <h3 className="portfolio-card-title">{project.title}</h3>
                  <p className="portfolio-card-desc">{project.description}</p>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      <section className="portfolio-services section">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            End-to-end software development and IT support
          </p>
          <div className="portfolio-service-pills">
            {servicePills.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="portfolio-pill"
              >
                {item.label}
              </Link>
            ))}
          </div>
          <div className="portfolio-cta-wrap">
            <Link to="/services" className="btn">
              View All Services
            </Link>
          </div>
        </div>
      </section>

      <section className="portfolio-contact section">
        <div className="container">
          <div className="portfolio-contact-inner">
            <h2>Have a project in mind?</h2>
            <p>Let's discuss how we can help you build it.</p>
            <Link to="/contact" className="btn">
              Get In Touch
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
